var React = require('react');

function CarouselArrow (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:#f7ba48;}")),React.createElement("path",{"className":"a","d":"M17,21.468l-15-15L6.468,2,17,12.532,27.532,2,32,6.468Z","transform":"translate(-2 32) rotate(-90)","key":1})]);
}

CarouselArrow.defaultProps = {"width":"19.468","height":"30","viewBox":"0 0 19.468 30"};

module.exports = CarouselArrow;

CarouselArrow.default = CarouselArrow;
